import { html } from "lit";
import { ActivityHistorySearchBar } from "./activity-history-search-bar";

export const template = (props: ActivityHistorySearchBar) =>
  html`<dss-search-bar dropdownStyle=${"display: none"} @onSearchChange=${props._handleSearchChange} icon="search" inputsize="md" threshold="2" recentsearchestext="" emptydropdowntext="">
                    <label slot="label" for="searchbar1" aria-hidden="false"></label>
                    <input slot="input" id="searchbar1" type="text" value=${props.searchQuery} @input=${(e) => props._handleSearchChange({ detail: [e.target.value] })}>
                </dss-search-bar>`;
